<template>
  <div class="content content--sub">
    <MyHeader :breadcrumbItems="[

        {
          name: pageName.name,
          path: `/${$route.params.companySlug}/global-delivery-network`
        },
        {
          name: region.value,
          path: `/${$route.params.companySlug}/global-delivery-network/${slugify(region.value)}`
        },
      ]"/>

    <header class="content-header">
      <h1>{{ region.value }}</h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
    </header>

    <!-- tabs for mobile -->
    <transition name="fade">
      <div class="article-list" v-if="showList">
<!--        <div class="tab-title" :key="year.id">Regions</div>-->
        <div class="tabs-vertical">
          <ul class="tabs-inner">
            <li v-for="(tab, index) in countries" :key="tab.idSettingCompany">
              <a :class="{'active': $route.query.tab ? (tab.idSettingCompany === $route.query.tab) : index === 0}" @click="selectTab(tab, tab.units[0])">
                {{tab.value}}
                <i class="icon-arrow"></i>
              </a>
              <ul>
                <template v-for="(subTab, subIndex) in tab.units">
                  <li :key="subTab.idSettingCompany" v-if="subTab.value !== '(No title)'">
                    <a @click="selectTab(tab, subTab)" :class="{'active': $route.query.subtab ? (subTab.idSettingCompany === $route.query.subtab) : (subIndex === 0 && tab.idSettingCompany === $route.query.tab)}">
                      <span>{{subTab.value}}</span>
                    </a>
                  </li>
                </template>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </transition>

    <div class="container main-content--tabbed">
      <div class="row">
        <div class="col-lg-3 d-none d-lg-block">
          <div class="tabs-vertical">
            <ul class="tabs-inner">
              <li v-for="(tab, index) in countries" :key="tab.idSettingCompany">
                <a :class="{'active': $route.query.tab ? (tab.idSettingCompany === $route.query.tab) : index === 0}" @click="selectTab(tab, tab.units[0])">
                  {{tab.value}}
                  <i class="icon-arrow"></i>
                </a>
                <ul v-if="!tab.intValue1">
                  <template v-for="(subTab, subIndex) in tab.units">
                    <li :key="subTab.idSettingCompany" v-if="subTab.value !== '(No title)'">
                      <a @click="selectTab(tab, subTab)" :class="{'active': $route.query.subtab ? (subTab.idSettingCompany === $route.query.subtab) : (subIndex === 0 && tab.idSettingCompany === $route.query.tab)}">
                        <span>{{subTab.value}}</span>
                      </a>
                    </li>
                  </template>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9 article-content" v-if="$route.query.subtab">
          <template v-for="item in content">
<!--            <h2 v-if="item.value !== '(No title)'" :key="`header-${item.idSettingCompany}`">{{item.value}}</h2>-->
            <HtmlContent :content="{contenthtml: item.valueDescription, sections: item.sections.map(elem => {return {value: elem.value, caption: elem.valueDescription, idSettingCompany: elem.idSettingCompany}})}" :key="item.idSettingCompany"></HtmlContent>
          </template>
        </div>
        <div class="col-lg-9 article-content" v-else>
          <HtmlContent :content="{contenthtml: country.valueDescription}" :key="country.idSettingCompany"></HtmlContent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import {slugify} from "@/helpers/slugify";
import HtmlContent from "@/components/general/HtmlContent";
import settings from "@/settings";

export default {
  name: "GlobalDeliveryNetworkSingle",
  components: {HtmlContent, MyHeader },
  data () {
    return {
      showList: false,
    }
  },
  computed: {
    content() {
      if(this.$route.query.subtab) {
        return this.$store.getters.gdnContent(this.$route.query.subtab)
      }
      return [];
    },
    region() {
      return this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.GDN_REGIONS).find(item => {
        return slugify(item.value) === this.$route.params.slug
      })
    },
    countries() {
      return this.$store.getters.gdnCountries(this.region.idSettingCompany)
    },
    country() {
      if(!this.countries.length) {
        return {}
      }
      if(this.$route.query.tab) {
        return this.countries.find((item) => {
          return item.idSettingCompany === this.$route.query.tab
        })
      }
      return this.countries[0]
    },
    pageName() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'GlobalDeliveryNetwork'
      })
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', this.region.value ]);
    window._paq.push(['trackPageView']);
  },
  methods: {
    slugify: slugify,
    selectTab(tab, subTab = null) {
      let query = {
        tab: tab.idSettingCompany,
      }
      if(!tab.intValue1 && subTab && subTab.value !== '(No title)') {
        query.subtab = subTab.idSettingCompany
      }
      this.$router.push({query})
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
